import { ApolloError } from '@apollo/client';
import * as React from 'react';

import Button from '@/components/elements/Button/BaseButton';
import ModalBase, { ModalBasicProps } from '@/components/layouts/Modal/Base';
import { getErrorCode, getLastError } from '@/lib/apollo/error';

import { ButtonContainer, Container, Icon, Title } from './style';

interface ErrorModalProps extends ModalBasicProps {
  apolloError?: ApolloError;
  customMessage?: string;
}

const ErrorModalContent: React.FC<ErrorModalProps> = ({
  apolloError,
  customMessage,
  handleClose,
}) => {
  const lastError = getLastError(apolloError);
  const errorCode = getErrorCode(lastError);

  const message =
    lastError && errorCode
      ? lastError.message
      : customMessage || 'システムエラーが発生しました。';

  return (
    <>
      <Container>
        <Icon />
        <Title>エラーが発生しました</Title>
        <p>{message}</p>
      </Container>
      <ButtonContainer>
        <Button
          bgColor="primary"
          size="m"
          radius="s"
          width={['100%', '320px']}
          height="56px"
          fontWeight="bold"
          onClick={() => handleClose()}
        >
          閉じる
        </Button>
      </ButtonContainer>
    </>
  );
};

const ErrorModal: React.FC<ErrorModalProps> = ({
  isOpen,
  customMessage,
  apolloError,
  handleClose,
}) => {
  return (
    <ModalBase isOpen={isOpen} handleClose={handleClose}>
      <ErrorModalContent
        isOpen={isOpen}
        apolloError={apolloError}
        customMessage={customMessage}
        handleClose={handleClose}
      />
    </ModalBase>
  );
};

export default ErrorModal;
